import styled from 'styled-components';

export const StyledLinkedin = styled.div``;
